<template>
  <!--弹窗-->
  <el-dialog width="800px" :title="'导入链接错误页面'" :visible.sync="visible" :before-close="handleClose" top="8vh">
    <el-table
        v-loading="loading"
        :data="list"
        size="mini"
        :row-class-name="tableRowClassName"
        border style="width: 100%;">
        <el-table-column
            label="第几个数据"
            width="150"
            align="center">
            <template slot-scope="scope">
                <span>{{ scope.row.line }}（Excel的第{{ scope.row.line + 1 }}行）</span>
            </template>
        </el-table-column>
        <el-table-column
            label="原因"
            align="center">
            <template slot-scope="scope">
                <span>{{ scope.row.url }} url 无法识别</span>
            </template>
        </el-table-column>
    </el-table>
    <el-row style="margin-top:17px; ">
      <el-button
        style="float:right;margin-left:6px;"
        size="mini"
        plain
        @click="handleClose(true)"
      >取 消</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            disabled: false
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: () => []
        },
        type_error: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        tableRowClassName(row) {
            if (row.row.code == -1) {
                return "warning-row";
            } else {
                return "success-success";
            }
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.disabled = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
/deep/.el-table .warning-row {
    background: #fef0f0;
}
/deep/.el-table .success-success {
    background: #ecf5ff;
}
/deep/.el-table tbody tr:hover > td {
    background-color: #ffffff !important;
}
</style>
